"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5062],{

/***/ 74595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X6": function() { return /* reexport */ Heading_Heading; },
  "xS": function() { return /* reexport */ LogoTrack_LogoTrack; },
  "ZP": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/constants.tsx
var ICON_HEIGHT = 24;
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/LogoCarousel.views.tsx


var PADDING = 20;
var LogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uwp5a20"
} : 0)("display:grid;justify-content:center;max-width:", 1000 + 2 * PADDING, "px;padding:", PADDING, "px;width:100%;margin:0 auto;grid-template-rows:auto ", ICON_HEIGHT, "px;row-gap:24px;" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/LogoCarousel.tsx


var _excluded = ["appearance", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var LogoCarousel_LogoCarousel = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var externalAppearance = _ref.appearance,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: appearance,
      children: children
    })
  }));
});
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/Heading.views.ts


var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1nt9jg50"
} : 0)("margin:0;grid-column:1/-1;text-align:center;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/Heading.tsx


var Heading_excluded = ["children", "tag", "variant", "tokens"];

function Heading_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Heading_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Heading_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Heading_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseHeading = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "p" : _ref$tag,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Heading_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, Heading_objectSpread(Heading_objectSpread(Heading_objectSpread({
    ref: ref,
    variant: variant,
    tag: tag
  }, rest), tokens), {}, {
    children: children
  }));
});
var Heading_Heading = (0,useDesignTokens/* withDesignTokens */.Y)(BaseHeading, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[60]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  }
});
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(75536);
// EXTERNAL MODULE: ../../node_modules/lodash/range.js
var range = __webpack_require__(2689);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useTimeoutFn.js
var useTimeoutFn = __webpack_require__(45641);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(71926);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/useLogoCarousel.tsx







var getLoopedIndex = function getLoopedIndex(index, length) {
  return (index % length + length) % length;
};

var PREV_ICONS_COUNT = 5;
var NEXT_ICONS_COUNT = 6;
var DISPLAYED_ICONS_COUNT = PREV_ICONS_COUNT + 1 + NEXT_ICONS_COUNT;
var useLogoCarousel = function useLogoCarousel(_ref) {
  var icons = _ref.icons,
      delay = _ref.delay,
      duration = _ref.duration;
  var animation = (0,use_animation/* useAnimation */._)(); // Initially interval is not running because the first animation should have shorter delay

  var _useState = (0,react.useState)(null),
      animationInterval = _useState[0],
      setAnimationInterval = _useState[1];

  var _useState2 = (0,react.useState)(PREV_ICONS_COUNT),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var displayedLogosIndices = range_default()(currentIndex - PREV_ICONS_COUNT, currentIndex + NEXT_ICONS_COUNT + 1).map(function (index) {
    return getLoopedIndex(index, icons.length);
  });
  var prevIndices = displayedLogosIndices.slice(0, PREV_ICONS_COUNT);
  var prevIcons = prevIndices.map(function (index) {
    return icons[index];
  });
  var currentIcon = icons[displayedLogosIndices[PREV_ICONS_COUNT]];
  var nextIndices = displayedLogosIndices.slice(PREV_ICONS_COUNT + 1);
  var nextIcons = nextIndices.map(function (index) {
    return icons[index];
  });

  var runAnimationStep = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return animation.start("toLeft");

            case 2:
              setCurrentIndex(function (prevIndex) {
                return getLoopedIndex(prevIndex + 1, icons.length);
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function runAnimationStep() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,useTimeoutFn/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setAnimationInterval(delay + duration);
            _context2.next = 3;
            return runAnimationStep();

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), delay);
  (0,useInterval/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return runAnimationStep();

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), animationInterval);
  return {
    animation: animation,
    prevIcons: prevIcons,
    currentIcon: currentIcon,
    nextIcons: nextIcons,
    currentIndex: currentIndex
  };
};
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/LogoTrack.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var LogoTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ehwbnk26"
} : 0)("background-color:inherit;position:relative;display:grid;grid-auto-flow:column;justify-content:center;align-items:center;width:100%;overflow:hidden;mask-image:linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%);color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehwbnk25"
} : 0)("display:grid;place-items:center;width:", function (_ref2) {
  var width = _ref2.width;
  return width;
}, "px;height:", function (_ref3) {
  var height = _ref3.height;
  return height;
}, "px;svg{width:100%;height:100%;vertical-align:middle;}" + ( true ? "" : 0));
var SlotWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ehwbnk24"
} : 0)("display:grid;grid-auto-flow:column;grid-template-columns:520px auto 520px;column-gap:", function (_ref4) {
  var gap = _ref4.gap;
  return gap;
}, "px;" + ( true ? "" : 0));

var SideSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehwbnk23"
} : 0)("display:grid;grid-auto-flow:column;column-gap:", function (_ref5) {
  var gap = _ref5.gap;
  return gap;
}, "px;width:520px;height:100%;overflow:visible;" + ( true ? "" : 0));

var LeftSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SideSlot,  true ? {
  target: "ehwbnk22"
} : 0)( true ? {
  name: "qaoegf",
  styles: "justify-content:right"
} : 0);
var RightSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SideSlot,  true ? {
  target: "ehwbnk21"
} : 0)( true ? {
  name: "1rk70o",
  styles: "justify-content:left"
} : 0);
var MiddleSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehwbnk20"
} : 0)( true ? {
  name: "13udsys",
  styles: "height:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/LogoTrack.tsx


var LogoTrack_excluded = ["duration", "delay", "icons", "tokens"];

function LogoTrack_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function LogoTrack_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? LogoTrack_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LogoTrack_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var SECOND = 1000;
var DEFAULT_DURATION = 3 * SECOND;
var DEFAULT_DELAY = 0.2 * SECOND;
var GAP = 40;
var MAX_ICON_WIDTH = 120;

var getNormalizedIconWidth = function getNormalizedIconWidth(_ref) {
  var width = _ref.width,
      height = _ref.height;
  var unboundedWidth = Math.round(width / height * ICON_HEIGHT);
  /*
    We want the width of the icon to be an even number so that we can safely divide it by 2
    when calculation animation step width (in `getAnimationStepWidth` function).
    This makes sure we avoid sub-pixel rendering.
  */

  var widthRoundedNearestToEven = Math.round(unboundedWidth / 2) * 2;
  return Math.min(widthRoundedNearestToEven, MAX_ICON_WIDTH);
};

var getAnimationStepWidth = function getAnimationStepWidth(currentIconWidth, nextIconWidth, gap) {
  return currentIconWidth / 2 + gap + nextIconWidth / 2;
};

var Icon = function Icon(_ref2) {
  var id = _ref2.id,
      IconComponent = _ref2.icon,
      width = _ref2.width,
      height = _ref2.height;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
    width: getNormalizedIconWidth({
      width: width,
      height: height
    }),
    height: ICON_HEIGHT,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconComponent, {})
  }, id);
};

var easing = [0.75, 0, 0.36, 0.99];
var BaseLogoTrack = /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? DEFAULT_DURATION : _ref3$duration,
      _ref3$delay = _ref3.delay,
      delay = _ref3$delay === void 0 ? DEFAULT_DELAY : _ref3$delay,
      icons = _ref3.icons,
      tokens = _ref3.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, LogoTrack_excluded);

  var carouselRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return carouselRef.current;
  });

  var _useLogoCarousel = useLogoCarousel({
    icons: icons,
    delay: delay,
    duration: duration
  }),
      prevIcons = _useLogoCarousel.prevIcons,
      currentIcon = _useLogoCarousel.currentIcon,
      nextIcons = _useLogoCarousel.nextIcons,
      currentIndex = _useLogoCarousel.currentIndex,
      animation = _useLogoCarousel.animation;

  var currentIconWidth = getNormalizedIconWidth(currentIcon);
  var nextIcon = nextIcons[0];
  var nextIconWidth = getNormalizedIconWidth(nextIcon);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTrack, LogoTrack_objectSpread(LogoTrack_objectSpread({
    ref: carouselRef
  }, rest), {}, {
    color: tokens.color,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SlotWrapper, {
      animate: animation,
      transition: {
        x: {
          ease: easing,
          duration: duration / SECOND
        }
      },
      variants: {
        toLeft: {
          x: "-".concat(getAnimationStepWidth(currentIconWidth, nextIconWidth, tokens.gap), "px")
        }
      },
      gap: tokens.gap,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftSlot, {
        gap: tokens.gap,
        children: prevIcons.map(function (icon) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, LogoTrack_objectSpread({}, icon), icon.id);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiddleSlot, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, LogoTrack_objectSpread({}, currentIcon))
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightSlot, {
        gap: tokens.gap,
        children: nextIcons.map(function (icon) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, LogoTrack_objectSpread({}, icon), icon.id);
        })
      })]
    }, currentIndex)
  }));
});
var LogoTrack_LogoTrack = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLogoTrack, function () {
  return {
    gap: GAP
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts



LogoCarousel_LogoCarousel.displayName = "LogoCarouselBase";
Heading_Heading.displayName = "LogoCarousel.Heading";
LogoTrack_LogoTrack.displayName = "LogoCarousel.LogoTrack";



/***/ }),

/***/ 43787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ carouselLogosMono; },
/* harmony export */   "j": function() { return /* binding */ carouselLogos; }
/* harmony export */ });
/* harmony import */ var _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13922);
/* harmony import */ var _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68536);


var carouselLogosMono = {
  RAKUTEN: {
    id: "rakuten",
    width: 89,
    height: 26,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .RakutenMonoLogo */ .kNq
  },
  DIGITAL_OCEAN: {
    id: "digital-ocean",
    width: 178,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DigitalOceanMonoLogo */ .G7L
  },
  IBM: {
    id: "ibm",
    width: 70,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .IbmMonoLogo */ .cEr
  },
  DOMINOS: {
    id: "dominos",
    width: 145,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DominosMonoLogo */ .ooH
  },
  ANHEUSER_BUSCH: {
    id: "anheuser-busch",
    width: 436,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AnheuserBuschMonoLogo */ .x5p
  },
  VMWARE: {
    id: "vmware",
    width: 148,
    height: 23,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .VmwareMonoLogo */ .qFJ
  },
  LEVIS: {
    id: "levis",
    width: 65,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .LevisMonoLogo */ .I0P
  },
  LOG_ME_IN: {
    id: "log-me-in",
    width: 99,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .LogMeInMonoLogo */ .B6Y
  },
  CLEAR_SCORE: {
    id: "clear-score",
    width: 157,
    height: 22,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ClearScoreMonoLogo */ .Ojb
  },
  VACASA: {
    id: "vacasa",
    width: 187,
    height: 37,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .VacasaMonoLogo */ .Ciy
  },
  STAPLES: {
    id: "staples",
    width: 172,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .StaplesMonoLogo */ .pV5
  },
  INTUIT: {
    id: "intuit",
    width: 83,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .IntuitMonoLogo */ .klV
  },
  THE_SKIMM: {
    id: "the-skimm",
    width: 64,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TheSkimmMonoLogo */ .h9z
  },
  DRIFT: {
    id: "drift",
    width: 92,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DriftMonoLogo */ .BPv
  },
  ALLERGAN: {
    id: "allergan",
    width: 144,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AllerganMonoLogo */ .ubl
  },
  GLOSSIER: {
    id: "glossier",
    width: 91,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .GlossierMonoLogo */ .WtD
  },
  AB_IN_BEV: {
    id: "ab-in-bev",
    width: 176,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AbInBevMonoLogo */ .gud
  },
  SEND_GRID: {
    id: "send-grid",
    width: 126,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .SendGridMonoLogo */ .s8v
  },
  ZENDESK: {
    id: "zendesk",
    width: 130,
    height: 28,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ZendeskMonoLogo */ .HhY
  },
  OPTIMIZELY: {
    id: "optimizely",
    width: 126,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .OptimizelyMonoLogo */ .LcO
  },
  DOCKER: {
    id: "docker",
    width: 125,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DockerMonoLogo */ .mgi
  },
  INVISION: {
    id: "invision",
    width: 87,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .InvisionMonoLogo */ .F7L
  },
  ATLASSIAN: {
    id: "atlassian",
    width: 168,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AtlassianMonoLogo */ .v_6
  },
  FOX: {
    id: "fox",
    width: 76,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FoxMonoLogo */ .xrs
  },
  GOOGLE: {
    id: "google",
    width: 95,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .GoogleMonoLogo */ .BTS
  },
  BONOBOS: {
    id: "bonobos",
    width: 136,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BonobosMonoLogo */ .Trx
  },
  THE_MOTLEY_FOOL: {
    id: "the-motley-fool",
    width: 118,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TheMotleyFoolMonoLogo */ .DeK
  },
  CRYPTO_COM: {
    id: "crypto-com",
    width: 167,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CryptoComMonoLogo */ .K9k
  },
  WEALTHSIMPLE: {
    id: "wealthsimple",
    width: 162,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .WealthsimpleMonoLogo */ .CIp
  },
  CHIME: {
    id: "chime",
    width: 112,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ChimeMonoLogo */ .qP3
  },
  EARNEST: {
    id: "earnest",
    width: 118,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .EarnestMonoLogo */ .Iei
  },
  BETTER_MORTGAGE: {
    id: "better-mortgage",
    width: 92,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BetterMortgageMonoLogo */ .G5m
  },
  TAXFIX: {
    id: "taxfix",
    width: 87,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TaxfixMonoLogo */ .SSj
  },
  INSTACART: {
    id: "instacart",
    width: 160,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .InstacartMonoLogo */ .aKg
  },
  APARTMENT_LIST: {
    id: "apartment-list",
    width: 186,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ApartmentListMonoLogo */ .buu
  },
  DOORDASH: {
    id: "doordash",
    width: 172,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DoordashMonoLogo */ .eTY
  },
  DELIVEROO: {
    id: "deliveroo",
    width: 120,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DeliverooMonoLogo */ .vTz
  },
  LENDING_TREE: {
    id: "lending-tree",
    width: 106,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .LendingTreeMonoLogo */ .B6T
  },
  HOTEL_TONIGHT: {
    id: "hotel-tonight",
    width: 157,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .HotelTonightMonoLogo */ .OXV
  },
  UPTV: {
    id: "uptv",
    width: 52,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .UptvMonoLogo */ ._O8
  },
  SCHIBSTED: {
    id: "schibsted",
    width: 126,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .SchibstedMonoLogo */ .rBc
  },
  FUBOTV: {
    id: "fubotv",
    width: 74,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FuboTvMonoLogo */ .E1F
  },
  BETTERMENT: {
    id: "betterment",
    width: 244,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BettermentMonoLogo */ .Cj6
  },
  DRAFT_KINGS: {
    id: "draft-kings",
    width: 95,
    height: 48,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DraftKingsMonoLogo */ .PSN
  },
  HOUSEPARTY: {
    id: "houseparty",
    width: 158,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .HousepartyMonoLogo */ .Qhc
  },
  SPOT_HERO: {
    id: "spot-hero",
    width: 52,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .SpotHeroMonoLogo */ .nPw
  },
  CLASS_PASS: {
    id: "class-pass",
    width: 214,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ClassPassMonoLogo */ .Va4
  },
  STYLEPIT: {
    id: "stylepit",
    width: 105,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .StylepitMonoLogo */ .$K_
  },
  PELETON: {
    id: "peleton",
    width: 109,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .PeletonMonoLogo */ .QRC
  },
  RUGS: {
    id: "rugs",
    width: 105,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .RugsComMonoLogo */ .ONK
  },
  TRADESY: {
    id: "tradesy",
    width: 166,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TradesyMonoLogo */ .qKx
  },
  ME_UNDIES: {
    id: "me-undies",
    width: 119,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .MeUndiesMonoLogo */ .ift
  },
  FENDER: {
    id: "fender",
    width: 86,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FenderMonoLogo */ .bf1
  },
  TRIVAGO: {
    id: "trivago",
    width: 107,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TrivagoMonoLogo */ .lEU
  },
  TOGGLE: {
    id: "toggle",
    width: 123,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ToggleMonoLogo */ .nSO
  },
  GOOD_EGGS: {
    id: "good-eggs",
    width: 52,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .GoodeggsMonoLogo */ .nCX
  },
  APP_DYNAMICS: {
    id: "app-dynamics",
    width: 200,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AppDynamicsMonoLogo */ .Y48
  },
  INTEGRA_BEAUTY: {
    id: "integra-beauty",
    width: 61,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .IntegraBeautyMonoLogo */ ._tx
  },
  CLEAN_CHOICE_ENERGY: {
    id: "clean-choice-energy",
    width: 87,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CleanChoiceEnergyMonoLogo */ .oo_
  },
  VISTA: {
    id: "vista",
    width: 87,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .VistaMonoLogo */ .szz
  },
  RITUAL: {
    id: "ritual",
    width: 64,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .RitualMonoLogo */ .qWP
  },
  SHIFT: {
    id: "shift",
    width: 80,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ShiftMonoLogo */ .$d9
  },
  VERONICA_BEARD: {
    id: "veronica-beard",
    width: 265,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .VeronicaBeardMonoLogo */ .i_T
  },
  VEO: {
    id: "veo",
    width: 63,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .VeoMonoLogo */ .Udw
  },
  ORCHARD: {
    id: "orchard",
    width: 103,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .OrchardMonoLogo */ .z20
  },
  STANLEY_SECURITY: {
    id: "stanley-security",
    width: 106,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .StanleySecurityMonoLogo */ .BE6
  },
  FIRST_HORIZON: {
    id: "first-horizon",
    width: 114,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FirstHorizonMonoLogo */ .UjF
  },
  FAIRE: {
    id: "faire",
    width: 145,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FaireMonoLogo */ .Wbq
  },
  CVS_HEALTH: {
    id: "cvs-health",
    width: 191,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CvsHealthMonoLogo */ .bgc
  },
  BLOOMINGDALES: {
    id: "bloomingdales",
    width: 158,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BloomingdalesMonoLogo */ .PrN
  },
  CONSTELLATION_RESEARCH: {
    id: "constellation-research",
    width: 146,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ConstellationResearchMonoLogo */ .LMk
  },
  ROKFIN: {
    id: "rokfin",
    width: 74,
    height: 24,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .RokfinMonoLogo */ .F3b
  },
  SLACK: {
    id: "slack",
    width: 108,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .SlackMonoLogo */ .Vnc
  },
  Y_COMBINATOR: {
    id: "y-combinator",
    width: 142,
    height: 31,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .YCombinatorMonoLogo */ .ah_
  },
  EVENTBRITE: {
    id: "eventbrite",
    width: 153,
    height: 28,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .EventbriteMonoLogo */ .akr
  },
  ANDREESSEN_HOROWITZ: {
    id: "andreesen-horowitz",
    width: 139,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AndreessenHorowitzMonoLogo */ .isq
  },
  SCOOP: {
    id: "scoop",
    width: 96,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ScoopMonoLogo */ .m24
  },
  IMPERFECT_FOODS: {
    id: "imperfect-foods",
    width: 77,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ImperfectFoodsMonoLogo */ .rQW
  },
  UBER: {
    id: "uber",
    width: 70,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .UberLogo */ .tgE
  },
  BOOKING: {
    id: "booking",
    width: 169,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BookingLogo */ .qml
  },
  YELP: {
    id: "yelp",
    width: 86,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .YelpLogo */ .GhW
  },
  SPOTIFY: {
    id: "spotify",
    width: 104,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SpotifyLogo */ .qkv
  },
  AIRBNB: {
    id: "airbnb",
    width: 104,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AirbnbLogo */ .xPT
  },
  ZIPRECRUITER: {
    id: "ziprecruiter",
    width: 143,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ZipRecruiterLogo */ .piu
  },
  ETSY: {
    id: "etsy",
    width: 60,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .EtsyLogo */ .n$U
  },
  BOX: {
    id: "box",
    width: 60,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BoxMonoLogo */ .Xb7
  },
  PEPSICO: {
    id: "pepsico",
    width: 138,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .PepsiCoMonoLogo */ .Soc
  },
  NEXTDOOR: {
    id: "nextdoor",
    width: 120,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .NextdoorMonoLogo */ .vNQ
  },
  GENERALMILLS: {
    id: "generalmills",
    width: 54,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .GeneralMillsMonoLogo */ .g2_
  },
  DSW: {
    id: "dsw",
    width: 118,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .DswMonoLogo */ .fqU
  },
  THENEWYORKTIMES: {
    id: "thenewyorktimes",
    width: 140,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TheNewYorkTimesMonoLogo */ .Rpd
  },
  TELUSDIGITAL: {
    id: "telusdigital",
    width: 140,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TelusDigitalMonoLogo */ .JuF
  },
  ANTHROPOLOGIE: {
    id: "anthropologie",
    width: 140,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AnthropologieMonoLogo */ .jS
  },
  SHOPIFY: {
    id: "shopify",
    width: 110,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ShopifyMonoLogo */ .rfH
  },
  HUBSPOT: {
    id: "hubspot",
    width: 97,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .HubspotMonoLogo */ .AiU
  },
  GITHUB: {
    id: "github",
    width: 119,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .GithubMonoLogo */ .UDQ
  },
  SANOFI: {
    id: "sanofi",
    width: 122,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .SanofiMonoLogo */ .he8
  },
  CRAFTJACK: {
    id: "craftjack",
    width: 113,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CraftJackMonoLogo */ .Vsb
  },
  REUTERS: {
    id: "reuters",
    width: 141,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ReutersMonoLogo */ .Kb0
  },
  TERADATA: {
    id: "teradata",
    width: 153,
    height: 30,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TeradataMonoLogo */ .X8u
  },
  CAMPING_WORLD: {
    id: "camping-world",
    width: 203,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CampingWorldHomeMonoLogo */ .P57
  },
  CROSS_FIT: {
    id: "cross-fit",
    width: 100,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CrossFitMonoLogo */ .DvB
  },
  FRAME_IO: {
    id: "frame-io",
    width: 129,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FrameIoMonoLogo */ .QzL
  },
  ANGI: {
    id: "angi",
    width: 53,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AngiMonoLogo */ .$gP
  },
  AUTODESK: {
    id: "autodesk",
    width: 312,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AutodeskMonoLogo */ .hix
  },
  AVANT: {
    id: "avant",
    width: 230,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .AvantMonoLogo */ .ANF
  },
  CRUNCHY_ROLL: {
    id: "crunchy-roll",
    width: 169,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CrunchyRollMonoLogo */ .hm_
  },
  CSAA: {
    id: "csaa-logo",
    width: 171,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .CsaaMonoLogo */ .qPf
  },
  FRASERS_GROUP: {
    id: "frasers-group",
    width: 253,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .FrasersGroupMonoLogo */ .RAX
  },
  IMAX: {
    id: "imax",
    width: 169,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ImaxMonoLogo */ .$kb
  },
  MADEIRA_MADEIRA: {
    id: "madeira-madeira",
    width: 228,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .MadeiraMadeiraMonoLogo */ .Bon
  },
  BRIGHTLINE: {
    id: "brightline",
    width: 131,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BrightlineMonoLogo */ .xT5
  },
  HATCH: {
    id: "hatch",
    width: 159,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .HatchMonoLogo */ .ReH
  },
  LEMONADE: {
    id: "lemonade",
    width: 141,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .LemonadeMonoLogo */ .cXS
  },
  OUTDOORSY: {
    id: "outdoorsy",
    width: 142,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .OutdoorsyMonoLogo */ .FjI
  },
  ROCKET_MONEY: {
    id: "rocket-money",
    width: 144,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .RocketMoneyMonoLogo */ .n7D
  },
  SWOOP: {
    id: "swoop",
    width: 93,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .SwoopMonoLogo */ .ews
  },
  TALK360: {
    id: "talk360",
    width: 170,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .Talk360MonoLogo */ .hNf
  },
  TAWKIFY: {
    id: "tawkify",
    width: 129,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .TawkifyMonoLogo */ .$0j
  },
  ZOLA: {
    id: "zola",
    width: 209,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .ZolaMonoLogo */ .U2C
  },
  PAGER_DUTY: {
    id: "pager-duty",
    width: 118,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .PagerDutyMonoLogo */ .e90
  },
  MIND_BODY_GREEN: {
    id: "pager-duty",
    width: 187,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .MindbodygreenMonoLogo */ .HG0
  },
  BABYLIST: {
    id: "babylist",
    width: 146,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_CompanyMono__WEBPACK_IMPORTED_MODULE_1__/* .BabylistMonoLogo */ .VQ4
  }
};
var carouselLogos = {
  RAKUTEN: {
    id: "rakuten",
    width: 89,
    height: 26,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .RakutenLogo */ .XjW
  },
  DIGITAL_OCEAN: {
    id: "digital-ocean",
    width: 178,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DigitalOceanLogo */ .L2p
  },
  IBM: {
    id: "ibm",
    width: 70,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .IbmLogo */ .D64
  },
  DOMINOS: {
    id: "dominos",
    width: 145,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DominosLogo */ .MYS
  },
  ANHEUSER_BUSCH: {
    id: "anheuser-busch",
    width: 436,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AnheuserBuschLogo */ .oO3
  },
  VMWARE: {
    id: "vmware",
    width: 148,
    height: 23,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .VmwareLogo */ .wDo
  },
  LEVIS: {
    id: "levis",
    width: 65,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .LevisLogo */ ._dL
  },
  LOG_ME_IN: {
    id: "log-me-in",
    width: 99,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .LogMeInLogo */ .R7S
  },
  CLEAR_SCORE: {
    id: "clear-score",
    width: 157,
    height: 22,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ClearScoreLogo */ .Kgu
  },
  VACASA: {
    id: "vacasa",
    width: 187,
    height: 37,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .VacasaLogo */ .WMh
  },
  STAPLES: {
    id: "staples",
    width: 172,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .StaplesLogo */ .Fk1
  },
  INTUIT: {
    id: "intuit",
    width: 83,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .IntuitLogo */ .M1u
  },
  THE_SKIMM: {
    id: "the-skimm",
    width: 64,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TheSkimmLogo */ ._XP
  },
  DRIFT: {
    id: "drift",
    width: 92,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DriftLogo */ .lZw
  },
  ALLERGAN: {
    id: "allergan",
    width: 144,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AllerganLogo */ .Rko
  },
  GLOSSIER: {
    id: "glossier",
    width: 91,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .GlossierLogo */ .s9K
  },
  AB_IN_BEV: {
    id: "ab-in-bev",
    width: 176,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AbInBevLogo */ .CUf
  },
  SEND_GRID: {
    id: "send-grid",
    width: 126,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SendGridLogo */ .E9G
  },
  ZENDESK: {
    id: "zendesk",
    width: 130,
    height: 28,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ZendeskLogo */ .DvZ
  },
  OPTIMIZELY: {
    id: "optimizely",
    width: 126,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .OptimizelyLogo */ .g3$
  },
  DOCKER: {
    id: "docker",
    width: 125,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DockerLogo */ .TaW
  },
  INVISION: {
    id: "invision",
    width: 87,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .InvisionLogo */ .gpt
  },
  ATLASSIAN: {
    id: "atlassian",
    width: 168,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AtlassianLogo */ .mWO
  },
  FOX: {
    id: "fox",
    width: 76,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FoxLogo */ .I_f
  },
  GOOGLE: {
    id: "google",
    width: 95,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .GoogleLogo */ .avg
  },
  BONOBOS: {
    id: "bonobos",
    width: 136,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BonobosLogo */ .aFD
  },
  THE_MOTLEY_FOOL: {
    id: "the-motley-fool",
    width: 118,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TheMotleyFoolLogo */ .P1C
  },
  CRYPTO_COM: {
    id: "crypto-com",
    width: 167,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CryptoComLogo */ .tY1
  },
  WEALTHSIMPLE: {
    id: "wealthsimple",
    width: 162,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .WealthsimpleLogo */ .GRc
  },
  CHIME: {
    id: "chime",
    width: 112,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ChimeLogo */ .O0
  },
  EARNEST: {
    id: "earnest",
    width: 118,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .EarnestLogo */ .LjI
  },
  BETTER_MORTGAGE: {
    id: "better-mortgage",
    width: 92,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BetterMortgageLogo */ .MWX
  },
  TAXFIX: {
    id: "taxfix",
    width: 87,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TaxfixLogo */ .IHh
  },
  INSTACART: {
    id: "instacart",
    width: 160,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .InstacartLogo */ .MyN
  },
  APARTMENT_LIST: {
    id: "apartment-list",
    width: 186,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ApartmentListLogo */ .q2j
  },
  DOORDASH: {
    id: "doordash",
    width: 172,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DoordashLogo */ .VYq
  },
  DELIVEROO: {
    id: "deliveroo",
    width: 120,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DeliverooLogo */ .Qe5
  },
  LENDING_TREE: {
    id: "lending-tree",
    width: 106,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .LendingTreeLogo */ .WIG
  },
  HOTEL_TONIGHT: {
    id: "hotel-tonight",
    width: 157,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .HotelTonightLogo */ .fct
  },
  UPTV: {
    id: "uptv",
    width: 52,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .UptvLogo */ .$LB
  },
  SCHIBSTED: {
    id: "schibsted",
    width: 126,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SchibstedLogo */ .Zq
  },
  FUBOTV: {
    id: "fubotv",
    width: 74,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FubotvLogo */ .ylr
  },
  BETTERMENT: {
    id: "betterment",
    width: 244,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BettermentLogo */ .dzg
  },
  DRAFT_KINGS: {
    id: "draft-kings",
    width: 95,
    height: 48,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DraftKingsLogo */ .run
  },
  HOUSEPARTY: {
    id: "houseparty",
    width: 158,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .HousepartyLogo */ .koD
  },
  SPOT_HERO: {
    id: "spot-hero",
    width: 52,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SpotHeroLogo */ ._E9
  },
  CLASS_PASS: {
    id: "class-pass",
    width: 214,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ClassPassLogo */ .ulZ
  },
  STYLEPIT: {
    id: "stylepit",
    width: 105,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .StylepitLogo */ .vcs
  },
  PELETON: {
    id: "peleton",
    width: 109,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .PeletonLogo */ .rRb
  },
  RUGS: {
    id: "rugs",
    width: 105,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .RugsComLogo */ .Qwy
  },
  TRADESY: {
    id: "tradesy",
    width: 166,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TradesyLogo */ .EF2
  },
  ME_UNDIES: {
    id: "me-undies",
    width: 119,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .MeUndiesLogo */ .fa9
  },
  FENDER: {
    id: "fender",
    width: 86,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FenderLogo */ .kV$
  },
  TRIVAGO: {
    id: "trivago",
    width: 107,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TrivagoLogo */ .SLS
  },
  TOGGLE: {
    id: "toggle",
    width: 123,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ToggleLogo */ .gwj
  },
  GOOD_EGGS: {
    id: "good-eggs",
    width: 52,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .GoodeggsLogo */ .jO8
  },
  APP_DYNAMICS: {
    id: "app-dynamics",
    width: 200,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AppDynamicsLogo */ .zFl
  },
  INTEGRA_BEAUTY: {
    id: "integra-beauty",
    width: 61,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .IntegraBeautyLogo */ .ien
  },
  CLEAN_CHOICE_ENERGY: {
    id: "clean-choice-energy",
    width: 87,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CleanChoiceEnergyLogo */ .hbT
  },
  VISTA: {
    id: "vista",
    width: 87,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .VistaLogo */ .BcN
  },
  RITUAL: {
    id: "ritual",
    width: 64,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .RitualLogo */ .QVK
  },
  SHIFT: {
    id: "shift",
    width: 80,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ShiftLogo */ .WGc
  },
  VERONICA_BEARD: {
    id: "veronica-beard",
    width: 265,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .VeronicaBeardLogo */ .GSB
  },
  VEO: {
    id: "veo",
    width: 63,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .VeoLogo */ .gVF
  },
  ORCHARD: {
    id: "orchard",
    width: 103,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .OrchardLogo */ .w1Y
  },
  STANLEY_SECURITY: {
    id: "stanley-security",
    width: 107,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .StanleySecurityLogo */ .Ic2
  },
  FIRST_HORIZON: {
    id: "first-horizon",
    width: 114,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FirstHorizonLogo */ .gmM
  },
  FAIRE: {
    id: "faire",
    width: 145,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FaireLogo */ .UC4
  },
  CVS_HEALTH: {
    id: "cvs-health",
    width: 191,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CvsHealthLogo */ .uLf
  },
  BLOOMINGDALES: {
    id: "bloomingdales",
    width: 158,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BloomingdalesLogo */ .aJ$
  },
  CONSTELLATION_RESEARCH: {
    id: "constellation-research",
    width: 146,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ConstellationResearchLogo */ .fYz
  },
  ROKFIN: {
    id: "rokfin",
    width: 74,
    height: 24,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .RokfinLogo */ .er9
  },
  SLACK: {
    id: "slack",
    width: 108,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SlackLogo */ .MA0
  },
  Y_COMBINATOR: {
    id: "y-combinator",
    width: 142,
    height: 31,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .YCombinatorLogo */ ._lL
  },
  EVENTBRITE: {
    id: "eventbrite",
    width: 153,
    height: 28,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .EventbriteLogo */ .I9g
  },
  ANDREESSEN_HOROWITZ: {
    id: "andreesen-horowitz",
    width: 139,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AndreessenHorowitzLogo */ .$zx
  },
  SCOOP: {
    id: "scoop",
    width: 96,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ScoopLogo */ .Wd_
  },
  IMPERFECT_FOODS: {
    id: "imperfect-foods",
    width: 77,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ImperfectFoodsLogo */ .iF3
  },
  UBER: {
    id: "uber",
    width: 70,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .UberLogo */ .tgE
  },
  BOOKING: {
    id: "booking",
    width: 169,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BookingLogo */ .qml
  },
  YELP: {
    id: "yelp",
    width: 86,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .YelpLogo */ .GhW
  },
  SPOTIFY: {
    id: "spotify",
    width: 104,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SpotifyLogo */ .qkv
  },
  AIRBNB: {
    id: "airbnb",
    width: 104,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AirbnbLogo */ .xPT
  },
  ZIPRECRUITER: {
    id: "ziprecruiter",
    width: 143,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ZipRecruiterLogo */ .piu
  },
  ETSY: {
    id: "etsy",
    width: 60,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .EtsyLogo */ .n$U
  },
  BOX: {
    id: "box",
    width: 60,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BoxLogo */ .R52
  },
  PEPSICO: {
    id: "pepsico",
    width: 138,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .PepsiCoLogo */ .Gy8
  },
  NEXTDOOR: {
    id: "nextdoor",
    width: 120,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .NextdoorLogo */ .XYj
  },
  GENERALMILLS: {
    id: "generalmills",
    width: 54,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .GeneralMillsLogo */ .dCV
  },
  DSW: {
    id: "dsw",
    width: 118,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .DswLogo */ .Nzt
  },
  THENEWYORKTIMES: {
    id: "thenewyorktimes",
    width: 140,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TheNewYorkTimesLogo */ .K5k
  },
  TELUSDIGITAL: {
    id: "telusdigital",
    width: 140,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TelusDigitalLogo */ .fTC
  },
  ANTHROPOLOGIE: {
    id: "anthropologie",
    width: 140,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AnthropologieLogo */ .UN$
  },
  SHOPIFY: {
    id: "shopify",
    width: 110,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ShopifyLogo */ .sEu
  },
  HUBSPOT: {
    id: "hubspot",
    width: 97,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .HubspotLogo */ .AKr
  },
  GITHUB: {
    id: "github",
    width: 119,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .GithubLogo */ .bYz
  },
  SANOFI: {
    id: "sanofi",
    width: 122,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SanofiLogo */ .usZ
  },
  CRAFTJACK: {
    id: "craftjack",
    width: 113,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CraftJackLogo */ .ZqF
  },
  REUTERS: {
    id: "reuters",
    width: 141,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ReutersLogo */ .FBh
  },
  TERADATA: {
    id: "teradata",
    width: 153,
    height: 30,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TeradataLogo */ .b5x
  },
  CAMPING_WORLD: {
    id: "camping-world",
    width: 203,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CampingWorldHomeLogo */ .ERG
  },
  CROSS_FIT: {
    id: "cross-fit",
    width: 100,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CrossFitLogo */ .pwh
  },
  FRAME_IO: {
    id: "frame-io",
    width: 129,
    height: 33,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FrameIoLogo */ .Ltd
  },
  ANGI: {
    id: "angi",
    width: 53,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AngiLogo */ .bQR
  },
  AUTODESK: {
    id: "autodesk",
    width: 312,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AutodeskLogo */ .y05
  },
  AVANT: {
    id: "avant",
    width: 230,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .AvantLogo */ .G79
  },
  CRUNCHY_ROLL: {
    id: "crunchy-roll",
    width: 169,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CrunchyRollLogo */ .nAJ
  },
  CSAA: {
    id: "csaa-logo",
    width: 171,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .CsaaLogo */ .HEf
  },
  FRASERS_GROUP: {
    id: "frasers-group",
    width: 253,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .FrasersGroupLogo */ .V_R
  },
  IMAX: {
    id: "imax",
    width: 169,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ImaxLogo */ .RYX
  },
  MADEIRA_MADEIRA: {
    id: "madeira-madeira",
    width: 228,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .MadeiraMadeiraLogo */ .sKw
  },
  BRIGHTLINE: {
    id: "brightline",
    width: 131,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BrightlineLogo */ .qis
  },
  HATCH: {
    id: "hatch",
    width: 159,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .HatchLogo */ .pkV
  },
  LEMONADE: {
    id: "lemonade",
    width: 141,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .LemonadeLogo */ .olc
  },
  OUTDOORSY: {
    id: "outdoorsy",
    width: 142,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .OutdoorsyLogo */ .e1j
  },
  ROCKET_MONEY: {
    id: "rocket-money",
    width: 144,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .RocketMoneyLogo */ .PsT
  },
  SWOOP: {
    id: "swoop",
    width: 93,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .SwoopLogo */ .Lok
  },
  TALK360: {
    id: "talk360",
    width: 170,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .Talk360Logo */ .phZ
  },
  TAWKIFY: {
    id: "tawkify",
    width: 129,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .TawkifyLogo */ .W9M
  },
  ZOLA: {
    id: "zola",
    width: 209,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .ZolaLogo */ .FYF
  },
  PAGER_DUTY: {
    id: "pager-duty",
    width: 118,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .PagerDutyLogo */ .Ilx
  },
  MIND_BODY_GREEN: {
    id: "pager-duty",
    width: 187,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .MindbodygreenLogo */ .xsW
  },
  BABYLIST: {
    id: "babylist",
    width: 146,
    height: 32,
    icon: _segment_matcha_components_CompanyLogos_Company__WEBPACK_IMPORTED_MODULE_0__/* .BabylistLogo */ .FTn
  }
};

/***/ })

}]);